/**
 * Enum para manejar estados de acciones en HTML
 */
export enum HtlmActionStatus {
  /** Estado inicial */
  Initial = 'initial',

  /** Estado de carga */
  Loading = 'loading',

  /** Estado de éxito */
  Success = 'success',

  /** Estado de error */
  Error = 'error'
}
